import React from 'react';
import { BeforeAfterPop } from './BeforeAfterPop';
import { BeforeAfterPopEntry } from 'schema';
import { SmartImage } from 'components/global/SmartImage';
import { Theme } from '../types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { RICH_TEXT_OPTIONS } from 'consts/contentful';

export const ContentfulBeforeAfterPop = ({
  examples,
  ...props
}: BeforeAfterPopEntry) => {
  return (
    <BeforeAfterPop
      examples={examples?.map(
        ({
          quote,
          clickableLogo,
          beforeImageMobile,
          afterImageMobile,
          beforeImageDesktop,
          afterImageDesktop,
          theme,
          ...exampleProps
        }) => {
          return {
            ...exampleProps,
            quote: quote && documentToReactComponents(quote, RICH_TEXT_OPTIONS),
            clickableLogo: clickableLogo && <SmartImage {...clickableLogo} />,
            beforeImageMobile: <SmartImage {...beforeImageMobile} />,
            afterImageMobile: <SmartImage {...afterImageMobile} />,
            beforeImageDesktop: <SmartImage {...beforeImageDesktop} />,
            afterImageDesktop: <SmartImage {...afterImageDesktop} />,
            theme: theme as Theme,
          };
        },
      )}
      {...props}
    />
  );
};
